/**
 * Richtiges Stoßlüften - Tipps für ein gesundes Raumklima
 *
 * Carried over from the old WordPress site, word for word. `legacyImage` records
 * the photograph the article used; every one of those files 404s from the origin
 * server, so nothing references them - the field exists so the pictures can be
 * wired back up if they ever turn up in a backup. Until then components/Cover.jsx
 * draws a cover from the slug.
 */
export const meta = {
  slug: 'richtiges-stosslueften-tipps-fuer-ein-gesundes-raumklima',
  title: 'Richtiges Stoßlüften - Tipps für ein gesundes Raumklima',
  date: '2023-12-17',
  category: 'Wohnen',
  excerpt:
    'Stoßlüften ist die einfachste Methode für frische Luft in den eigenen vier Wänden - und effizienter als dauerhaft gekippte Fenster. Wie es richtig geht.',
  /** Reading time, stated rather than counted: the body is markup now. */
  minutes: 1,
  legacyImage: 'woman-hand-opens-the-window-2023-11-27-05-06-24-utc-scaled.jpg',
  legacyAlt: 'Female hand opens the window to the street, close-up',
}

export default function Article() {
  return (
    <>
      <p>
        Die Qualität der Luft in unseren Wohnräumen spielt eine
        entscheidende Rolle für unser Wohlbefinden und unsere Gesundheit.
        Eine einfache, aber effektive Methode, um für frische Luft in den
        eigenen vier Wänden zu sorgen, ist das Stoßlüften. Doch wie genau
        geht richtiges Stoßlüften? In diesem Artikel erfahren Sie, warum
        Stoßlüften wichtig ist und erhalten praktische Tipps für die
        optimale Umsetzung.
      </p>
      <h2>Warum ist Stoßlüften wichtig?</h2>
      <p>
        In geschlossenen Räumen sammeln sich Schadstoffe, Gerüche,
        Feuchtigkeit und CO2 an. Ein schlechtes Raumklima kann nicht nur zu
        gesundheitlichen Problemen führen, sondern auch die Konzentration
        und das Wohlbefinden beeinträchtigen. Stoßlüften ist eine einfache
        Methode, um verbrauchte Luft durch frische Luft von außen zu
        ersetzen und insbesondere im Badezimmer Schimmel zu vermeiden. Im
        Vergleich zum dauerhaften Kipplüften ist das Stoßlüften effizienter
        und energiesparender.
      </p>
      <h2>Tipps für richtiges Stoßlüften</h2>
      <ul>
        <li>
          <strong>Frequenz und Dauer:</strong> Lüften Sie mehrmals täglich
          für etwa 5 bis 10 Minuten mit vollständig geöffneten Fenstern.
          Diese kurzen, aber intensiven Lüftungsphasen reichen aus, um die
          Luft effektiv auszutauschen, ohne unnötig Energie zu verbrauchen.
        </li>
        <li>
          <strong>Fenster weit öffnen:</strong> Öffnen Sie alle Fenster
          weit, damit ein effektiver Luftaustausch stattfinden kann. Türen
          sollten während des Stoßlüftens geschlossen bleiben, um Zugluft zu
          vermeiden.
        </li>
        <li>
          <strong>Durchzug nutzen:</strong> Nutzen Sie den Durchzugseffekt,
          indem Sie Fenster auf gegenüberliegenden Seiten öffnen. Dadurch
          wird die Luft im Raum optimal ausgetauscht.
        </li>
        <li>
          <strong>Lüftung bei Bedarf:</strong> Stoßlüften Sie besonders nach
          Kochen, Duschen oder wenn viele Personen im Raum sind. Diese
          Aktivitäten führen zu einer erhöhten Luftfeuchtigkeit und einem
          Anstieg von CO2.
        </li>
      </ul>
      <h2>Fazit</h2>
      <p>
        Richtiges Stoßlüften ist eine einfache und effektive Maßnahme, um
        für ein gesundes Raumklima zu sorgen und Energie zu sparen. Durch
        regelmäßiges und bewusstes Lüften können Sie nicht nur die
        Luftqualität in Ihren Wohnräumen verbessern, sondern auch das
        Wohlbefinden und die Produktivität steigern. Machen Sie das
        Stoßlüften zu einer festen Gewohnheit - Ihre Gesundheit wird es
        Ihnen danken.
      </p>
    </>
  )
}
